module.exports = __webpack_public_path__ + "media/images/emblems/Winznau-blason-07f0bbb5b7babcae04b59e14e924b956.png";